var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0D1116",
    d: "M17.282,5.494,8.379.078a.55.55,0,0,0-.823.5V11.421a.55.55,0,0,0,.823.5l8.9-5.416A.6.6,0,0,0,17.282,5.494Z",
    transform: "translate(-7.556 -8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPlay);
export default __webpack_public_path__ + "static/media/audio_play.414df8a3536589b7fe5d58c053192478.svg";
export { ForwardRef as ReactComponent };